import React, { useEffect, useState } from 'react';
import {
  Box,
  Checkbox,
  IconButton,
  Typography,
  Modal,
  Button,
  ThemeProvider,
  FormControlLabel,
  TextField,
  Tooltip,
} from '@mui/material';
import { produce } from 'immer';

import {
  IFormData,
  IDocumentInput,
  IForm,
  IUserDocumentSection,
} from '@homeporter/types';
import { COLORS } from '../../../../utils/colors';

import LinkIcon from '@mui/icons-material/Link';
import theme from '../../../../components/KnowledgeLibrary/theme';

const setCheckMark = (item: IDocumentInput, i: number = -1) => {
  const mark =
    item.uir !== undefined
      ? (i > -1 ? item.uir.charAt(i) : item.uir) === '1'
        ? 'u'
        : ''
      : item.air !== undefined
        ? (i > -1 ? item.air.charAt(i) : item.air) === '1'
          ? 'a'
          : ''
        : (i > -1 ? item.value?.charAt(i) : item.value) === '1'
          ? 'o'
          : '';

  return mark;
};
interface _function {
  (sid: string): void;
}
interface FormDataProps {
  itemKey: string;
  index: number;
  styles: any;
  formCard: IForm;
  documentSection: IUserDocumentSection;
  setDocumentSection: (section: IUserDocumentSection) => void;
  setSaveEnabled: (enabled: boolean) => void;
  highlightedSids: string[];
  setHighlightedSids: (sids: string[]) => void;
  setHighlightSentence: (_: _function | undefined) => void;
}

/*
  todo:
  - when manual user input, allow user to selected senetences from transcript.



*/

const FormBlock = ({
  itemKey,
  index,
  styles,
  formCard,
  documentSection,
  setDocumentSection,
  setSaveEnabled,
  highlightedSids,
  setHighlightedSids,
  setHighlightSentence,
}: FormDataProps) => {
  const [data, setData] = useState<IFormData[]>([]);
  const [checkedItems, setCheckedItems] = useState<Record<string, string>>({});
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const data: IFormData[] = formCard?.data || [];
    setData(data);

    if (data.length === 0) {
      setCheckedItems({});
      return;
    }

    const checked: Record<string, string> = {};

    data.map((sectionEntry, sectionIndex) =>
      sectionEntry.children.map((child, childIndex) =>
        child.items.map((item: IDocumentInput, idx: number) => {
          if (item.type === 'boolean') {
            checked[item.idx] = setCheckMark(item);
          } else if (Array.isArray(item.type)) {
            item.type.forEach((option, i) => {
              checked[item.idx + '-' + i] = setCheckMark(item, i);
            });
          }
        }),
      ),
    );

    console.log(':::::checked:', checked);
    setCheckedItems(checked);
  }, [formCard?.id]);

  const handleCheckItem = (
    sectionIndex: number,
    childIndex: number,
    itemIndex: number,
    i: number = -1,
  ) => {
    const item = data[sectionIndex].children[childIndex].items[itemIndex];
    const id = i > -1 ? `${item.idx}-${i}` : `${item.idx}`;

    console.log(':::::handleCheckItem item:', item);

    if (formCard.validated) {
      setModalOpen(true);
      return;
    }

    const newMark = checkedItems[id]
      ? ''
      : item.asids &&
          (item.type === 'boolean'
            ? item.air === '1'
            : item.air?.charAt(i) === '1')
        ? 'a'
        : 'u';

    console.log(':::::newMark:', newMark);

    // 1) update checkedItems immutably
    setCheckedItems((prev) => ({ ...prev, [id]: newMark }));

    // 2) update data immutably with Immer
    setData((prev) =>
      produce(prev, (draft) => {
        const draftItem =
          draft[sectionIndex].children[childIndex].items[itemIndex];

        if (draftItem.type === 'boolean') {
          const uir = newMark !== '' ? '1' : '0';
          draftItem.uir = uir === draftItem.air ? undefined : uir;
          return;
        }

        if (Array.isArray(draftItem.type)) {
          if (
            !draftItem.uir ||
            draftItem.uir.length !== draftItem.type.length
          ) {
            const baseline = draftItem.air || draftItem.value || '';
            draftItem.uir = baseline.padEnd(draftItem.type.length, '0');
          }

          const ch = newMark !== '' ? '1' : '0';
          draftItem.uir =
            draftItem.uir.substring(0, i) + ch + draftItem.uir.substring(i + 1);
        }

        console.log(':::::newMark:', newMark);
        console.log(':::::draftItem:', draftItem);
      }),
    );

    setSaveEnabled(true);
    setHighlightedSids([]);
  };

  useEffect(() => {
    console.log(':::::update documentSection...');

    (documentSection.cards[index] as IForm).data = data;
    //console.log('::::setDocument section 12...');
    //setDocumentSection({ ...documentSection });
  }, [data]);

  /*
  #e8f7f8
  #b7e4e6
  #8fd2d4
  #5bbfc2
	#8FD2D4	
	#7CBEBF	
	#69AAAA	
	#569696	
	#437F80	
	#306A6B
  */

  console.log(':::::render FormBlock formCard...');

  return (
    <>
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="validation-modal"
        aria-describedby="validation-modal-description">
        <Box sx={styles.modal}>
          <Typography id="validation-modal" variant="h6" component="h2">
            Cannot Edit Validated Checklist
          </Typography>
          <Typography id="validation-modal-description" sx={{ mt: 2 }}>
            This checklist is validated and cannot be edited.
          </Typography>
          <Button
            onClick={() => setModalOpen(false)}
            sx={{ mt: 2 }}
            variant="contained">
            OK
          </Button>
        </Box>
      </Modal>

      <ThemeProvider theme={theme}>
        {data.map((sectionEntry, sectionIndex) => (
          <Box
            sx={{ paddingLeft: '1rem' }}
            key={sectionEntry.title || sectionIndex}>
            <h3
              style={{
                margin: '0 .5rem',
                fontWeight: '600',
              }}>
              {sectionEntry.title}
            </h3>
            {sectionEntry.children.map((child, childIndex) => (
              <Box
                sx={{ paddingLeft: '1rem' }}
                key={child.subtitle || childIndex}>
                <h4 style={{ margin: '.5rem 0', fontWeight: '500' }}>
                  {child.subtitle}
                </h4>
                {child.items.map((item: IDocumentInput, idx: number) => {
                  const color =
                    item.uir !== undefined
                      ? COLORS.PRIMARY
                      : item.air !== undefined
                        ? '#5bbfc2'
                        : 'inherit';

                  const tooltip = [
                    item.value &&
                      (item.air || item.uir) &&
                      `Original Input: ${item.value}`,
                    item.air && item.uir && `AI Input: ${item.air}`,
                  ]
                    .filter(Boolean)
                    .join(', ');

                  return (
                    <Box
                      sx={styles.formItem}
                      key={item.id ?? item.idx}
                      id={item.asids?.join(',')}>
                      {item.type === 'boolean' && (
                        <Checkbox
                          id={`${item.idx}`}
                          sx={{
                            ...styles.formCheckbox,
                            '& .MuiSvgIcon-root': {
                              color: `${color}!important`,
                            },
                          }}
                          checked={!!checkedItems[item.idx]}
                          onChange={(e) => {
                            e.stopPropagation();
                            handleCheckItem(sectionIndex, childIndex, idx);
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        />
                      )}
                      <Typography style={{ margin: 0, whiteSpace: 'nowrap' }}>
                        {item.label}
                      </Typography>
                      {(item.type === 'string' || Array.isArray(item.type)) && (
                        <Box sx={styles.formInputContainer}>
                          {Array.isArray(item.type) ? (
                            item.type.map((option, i) => {
                              const color =
                                checkedItems[item.idx + '-' + i] === 'u'
                                  ? COLORS.PRIMARY
                                  : checkedItems[item.idx + '-' + i] === 'a'
                                    ? '#5bbfc2'
                                    : 'inherit';

                              return (
                                <FormControlLabel
                                  key={i}
                                  control={
                                    <Checkbox
                                      id={`${item.idx}-${i}`}
                                      checked={
                                        !!checkedItems[item.idx + '-' + i]
                                      }
                                      sx={{
                                        '&.Mui-checked': {
                                          color: `${color}!important`,
                                        },
                                      }}
                                    />
                                  }
                                  label={option}
                                  onChange={(e) => {
                                    e.stopPropagation();
                                    handleCheckItem(
                                      sectionIndex,
                                      childIndex,
                                      idx,
                                      i,
                                    );
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                />
                              );
                            })
                          ) : (
                            <Tooltip
                              title={tooltip}
                              placement="top"
                              arrow
                              slotProps={styles.tooltip}>
                              <TextField
                                size="small"
                                variant="outlined"
                                fullWidth
                                sx={{
                                  ...styles.formInput,

                                  '& fieldset': {
                                    borderColor: `${color}!important`,
                                  },
                                  '&:hover fieldset': {
                                    borderColor: `${color}!important`,
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: `${color}!important`,
                                  },
                                }}
                                value={item.uir || item.air || item.value || ''}
                                onChange={(e) => {
                                  setSaveEnabled(true);
                                  setData((prev) =>
                                    produce(prev, (draft) => {
                                      const draftItem =
                                        draft[sectionIndex].children[childIndex]
                                          .items[idx];

                                      draftItem.uir =
                                        draftItem.air === e.target.value
                                          ? undefined
                                          : e.target.value;
                                    }),
                                  );
                                }}
                                onClick={(e) => e.stopPropagation()}
                              />
                            </Tooltip>
                          )}
                        </Box>
                      )}
                      {item.asids ? (
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            setHighlightedSids(
                              highlightedSids === item.asids
                                ? []
                                : item.asids || [],
                            );
                          }}
                          sx={{
                            ...styles.iconButton,
                            marginLeft: 'auto',
                            backgroundColor:
                              highlightedSids === item.asids
                                ? '#ffdab3'
                                : highlightedSids === item.asids
                                  ? '#e8f7f8'
                                  : 'inherit', //#FFFACD
                          }}>
                          <LinkIcon fontSize="small" />
                        </IconButton>
                      ) : (
                        <Box sx={{ width: '2.875rem' }} />
                      )}
                    </Box>
                  );
                })}
              </Box>
            ))}
          </Box>
        ))}
      </ThemeProvider>
    </>
  );
};

export default FormBlock;
